<form [formGroup]="formProcedimiento" class="fb-dialog" (ngSubmit)="openConfirmDialog()">

  <h2 mat-dialog-title class="fb-dialog__title">{{ getTitle() }}</h2>

  <mat-dialog-content class="fb-dialog__content">

    <div class="fb-card">
      <div class="fb-card__header">{{ 'PROCEDIMIENTOS.FORM.ID' | translate }}</div>
      <div class="fb-card__body">

        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.NAME' | translate }} <span class="fb-req">*</span></label>
          <input type="text" class="fb-input" formControlName="nombre" name="nombre"
            [placeholder]="'PROCEDIMIENTOS.FORM.NAME_PH' | translate">
          <div *ngIf="formProcedimiento.get('nombre')?.invalid && formProcedimiento.get('nombre')?.touched" class="fb-error">
            {{ 'PROCEDIMIENTOS.FORM.NAME_ERR' | translate }}
          </div>
        </div>

        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.CODE' | translate }} <span class="fb-req">*</span></label>
          <input type="text" class="fb-input" formControlName="codigo" name="codigo"
            [placeholder]="'PROCEDIMIENTOS.FORM.CODE_PH' | translate">
          <div *ngIf="formProcedimiento.get('codigo')?.invalid && formProcedimiento.get('codigo')?.touched" class="fb-error">
            {{ 'PROCEDIMIENTOS.FORM.CODE_ERR' | translate }}
          </div>
        </div>

        <div class="fb-row">
          <div class="fb-col fb-col--6">
            <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.SIA' | translate }} <span class="fb-req">*</span></label>
            <input type="text" class="fb-input" formControlName="sia" name="sia" [placeholder]="'PROCEDIMIENTOS.FORM.SIA_PH' | translate">
            <div *ngIf="formProcedimiento.get('sia')?.invalid && formProcedimiento.get('sia')?.touched" class="fb-error">
              {{ 'PROCEDIMIENTOS.FORM.SIA_ERR' | translate }}
            </div>
          </div>

          <div class="fb-col fb-col--6">
            <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.IDENT' | translate }} <span class="fb-req">*</span></label>
            <input type="text" class="fb-input" formControlName="identificador" name="identificador"
              [placeholder]="'PROCEDIMIENTOS.FORM.IDENT_PH' | translate">
            <div *ngIf="formProcedimiento.get('identificador')?.invalid && formProcedimiento.get('identificador')?.touched" class="fb-error">
              {{ 'PROCEDIMIENTOS.FORM.IDENT_ERR' | translate }}
            </div>
          </div>
        </div>

        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.DEPT' | translate }} <span class="fb-req">*</span></label>
          <select class="fb-input fb-select" formControlName="departamentoId">
            <option [ngValue]="null" disabled>{{ 'PROCEDIMIENTOS.FORM.DEPT_PH' | translate }}</option>
            <option *ngFor="let dep of departamentos" [ngValue]="dep.id">
              {{ dep.nombre }}
            </option>
          </select>
          <div *ngIf="formProcedimiento.get('departamentoId')?.invalid && formProcedimiento.get('departamentoId')?.touched" class="fb-error">
            {{ 'PROCEDIMIENTOS.FORM.DEPT_ERR' | translate }}
          </div>
        </div>
        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.TYPE' | translate }}</label>
          <input
            type="text"
            class="fb-input"
            [value]="procedimiento?.custom ? ('PROCEDIMIENTOS.FORM.TYPE_DYN' | translate) : ('PROCEDIMIENTOS.FORM.TYPE_STD' | translate)"
            readonly>
        </div>
      </div>
    </div>

    <div class="fb-card">
      <div class="fb-card__header">{{ 'PROCEDIMIENTOS.FORM.LINKS' | translate }}</div>
      <div class="fb-card__body">

        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.LINK_HELP' | translate }}</label>
          <input type="text" class="fb-input" formControlName="link_ayuda" name="link_ayuda" placeholder="https://...">
        </div>

        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.LINK_ORD' | translate }}</label>
          <input type="text" class="fb-input" formControlName="link_ordenanza" name="link_ordenanza" placeholder="https://...">
        </div>

        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.LINK_PATH' | translate }}</label>
          <input type="text" class="fb-input" formControlName="link_path" name="link_path" placeholder="/ruta/...">
        </div>

      </div>
    </div>

    <div class="fb-card">
      <div class="fb-card__header">{{ 'PROCEDIMIENTOS.FORM.VALIDITY' | translate }}</div>
      <div class="fb-card__body">

        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.DATE_ACTIVE' | translate }}</label>
          <div class="fb-datetime">
            <input type="date" class="fb-input" formControlName="fechaApertura">
            <input type="time" class="fb-input fb-input--time" formControlName="horaApertura">
          </div>
          <div *ngIf="fechaAperturaIncompletaWarning" class="fb-alert">
            <p>{{ 'PROCEDIMIENTOS.FORM.DATE_INCOMPLETE' | translate }}</p>
          </div>
        </div>

        <div class="fb-col fb-col--12">
          <label class="fb-label">{{ 'PROCEDIMIENTOS.FORM.DATE_INACTIVE' | translate }}</label>
          <div class="fb-datetime">
            <input type="date" class="fb-input" formControlName="fechaCierre">
            <input type="time" class="fb-input fb-input--time" formControlName="horaCierre">
          </div>
          <div *ngIf="fechaCierreIncompletaWarning" class="fb-alert">
            <p>{{ 'PROCEDIMIENTOS.FORM.DATE_INCOMPLETE' | translate }}</p>
          </div>
        </div>

        <label class="fb-toggle" *ngIf="!ocultarVisible">
          <input type="checkbox" formControlName="visible">
          <span class="fb-toggle__track">
            <span class="fb-toggle__thumb"></span>
          </span>
          <span class="fb-toggle__text">{{ 'COMMON.ACTIVE' | translate }}</span>
        </label>

      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="fb-dialog__actions">
    <button type="button" class="fb-btn fb-btn--ghost" (click)="onNoClick()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="submit" class="fb-btn fb-btn--primary" [disabled]="formProcedimiento.invalid">{{ 'COMMON.SAVE' | translate }}</button>
  </mat-dialog-actions>

</form>
